import angular from 'angular';
import commissionEnquiry from './commissionEnquiry';
import './style.scss';

export default angular
  .module('components.commissionEnquiry', [])
  .component('commissionEnquiry', commissionEnquiry).name;
